module.exports = __webpack_public_path__ + "img/engagementbox.2772c98.webp";